/**
 * EstimateRow — canonical row for calculated / speculative values.
 *
 * Collapsed by default, marked "Indicative". Click expands a list of
 * methodology assumptions so the user can judge how reliable the
 * estimate is BEFORE acting on it.
 *
 * Examples of values that belong here, not in DataRow:
 *   - Annual energy cost (depends on utilisation assumption)
 *   - Total CAPEX (sum of per-component heuristics)
 *   - Fibre lease estimate
 *   - LCOH / LCOD
 *   - Permit timeline
 *
 * Audit 2026-05-27 (restructure): introduced to make the panel
 * distinguish "measured" from "modelled" at a glance.
 */

import React from 'react';

export default function EstimateRow({ label, range, midpoint, assumptions = [], status }) {
  if (range == null && midpoint == null) return null;

  return (
    <details className="estimate-row">
      <summary>
        <span className="label">{label}</span>
        <span className="range numeric">
          {status && <span className={`status-dot ${status}`} />}
          {range != null ? range : midpoint}
        </span>
        <span className="indicator">Indicative</span>
      </summary>
      {(assumptions.length > 0 || midpoint != null) && (
        <div className="assumptions">
          <div className="assumption-heading">Methodology</div>
          <ul>
            {midpoint != null && range != null && (
              <li>Midpoint: {midpoint} (range {range})</li>
            )}
            {assumptions.map((a, i) => <li key={i}>{a}</li>)}
          </ul>
        </div>
      )}
    </details>
  );
}
